import React from "react";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { signInWithGoogle, signInWithFacebook } from "../../../firebase";
import * as Actions from '../../../redux/actions/';
import GoogleButton from 'react-google-button';
import { FacebookLoginButton } from "react-social-login-buttons";

const SocialSignin = ({ isAuthenticating, setIsAuthenticating }) => {
	const handelSignInWithGoogle = () => {
		setIsAuthenticating(true);
		signInWithGoogle();
	}
	const handelSignInWithFacebook = () => {
		setIsAuthenticating(true);
		signInWithFacebook();
	}
  return (
    <div className="social-signin">
      <GoogleButton onClick={handelSignInWithGoogle} />
			<FacebookLoginButton onClick={handelSignInWithFacebook} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
		isAuthenticating: state.isAuthenticating
  }
}

const mapDispatchToProps = {
	setIsAuthenticating: Actions.setIsAuthenticating
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps)
)(SocialSignin);
